import { UIBidTypes } from 'modules/domain/bid/types'
import { updateSortOrder } from 'modules/domain/common/tableUtils'
import { ListRequestParams } from 'modules/domain/types'
import { ExtendedColumnType } from 'modules/types'
import { FC, useMemo } from 'react'
import ATableFullPage from 'views/components/Table/ATableFullPage'

interface Props {
  bidType: `${UIBidTypes}`
  listRequestParams: ListRequestParams
  setListRequestParams: (params: ListRequestParams) => void
  isFiltersLoaded: boolean
  dataEndpoint: string
  columnsFunc: (sort?: string) => ExtendedColumnType[]
}

const BidTable: FC<Props> = ({
  isFiltersLoaded,
  dataEndpoint,
  listRequestParams,
  setListRequestParams,
  columnsFunc,
}) => {
  const columns = columnsFunc()

  const sorted = useMemo(() => updateSortOrder(columns, listRequestParams.sort), [columns, listRequestParams.sort])
  return (
    <ATableFullPage
      columns={sorted}
      dataEndpoint={dataEndpoint}
      listParamsUpdated={setListRequestParams}
      listRequestParams={listRequestParams}
      isFiltersLoaded={isFiltersLoaded}
      rowHoverGray
    />
  )
}

export default BidTable
